import React, { useEffect, useState, useMemo } from "react";
import './Home.css';
import Footer from "./Footer";
import NavbarHome from "./NavbarHome";
import Content from "./Content";

const Home = (props) => {

  return (
    <div id="home">
      <div className="relative">
        <NavbarHome logout={props.logout} user={props.user}  diffOrg={props.diffOrg} changeUser={props.changeUser}/>
        <Content user={props.user}/>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
